"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var placementMap = {
  'top': 'top',
  'right': 'right',
  'bottom': 'bottom',
  'left': 'left',
  'top-left': 'topLeft',
  'top-right': 'topRight',
  'bottom-left': 'bottomLeft',
  'bottom-right': 'bottomRight',
  'left-top': 'leftTop',
  'left-bottom': 'leftBottom',
  'right-top': 'rightTop',
  'right-bottom': 'rightBottom'
};

var _normalizeDelay = function _normalizeDelay(delay) {
  var _defaultDelay = {
    enter: 0,
    leave: 0.1
  };

  if (!delay) {
    return _defaultDelay;
  }

  if (typeof delay !== 'object') {
    delay = {
      enter: delay
    };
  }

  return _objectSpread(_objectSpread({}, _defaultDelay), delay);
};

var Tooltip = function Tooltip(props) {
  var content = props.content,
      children = props.children,
      className = props.className,
      delay = props.delay,
      visible = props.visible,
      getContainer = props.getContainer,
      maxWidth = props.maxWidth,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'hover' : _props$trigger,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["content", "children", "className", "delay", "visible", "getContainer", "maxWidth", "placement", "trigger"]);
  var _placement = placementMap[placement];

  var _delay = React.useMemo(function () {
    return _normalizeDelay(delay);
  }, [delay]);

  var _otherProps = _objectSpread({}, otherProps);

  if (visible != null) {
    _otherProps.visible = visible;
  }

  var _style = {};

  if (maxWidth != null) {
    _style.maxWidth = maxWidth;
  }

  return React.createElement(_rcTooltip.default, Object.assign({}, _otherProps, {
    prefixCls: "Tooltip",
    transitionName: "Tooltip--animation",
    placement: _placement,
    overlay: content,
    overlayClassName: className,
    overlayStyle: _style,
    mouseEnterDelay: _delay.enter,
    mouseLeaveDelay: _delay.leave,
    trigger: trigger,
    getPopupContainer: getContainer
  }), children);
};

var _default = Tooltip;
exports.default = _default;